import {TalepOnaySeviye} from './talep-onay-seviye';

export class TalepTalepOnaySeviye {
  talepOnaySeviye: TalepOnaySeviye;
  isOnay: boolean;


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.talepOnaySeviye != null) {
      this.talepOnaySeviye = new TalepOnaySeviye(obj.talepOnaySeviye);
    }
  }

  get isOnayText(): string {
    if (this.isOnay == null) {
      return 'Onay Bekliyor';
    }
    if (this.isOnay) {
      return 'Onaylandı';
    }
    if (!this.isOnay) {
      return 'Rededildi';
    }
    return '';
  }
}
